<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              New Record
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <form>
                <div class="form-group">
                  <label for="apn">APN</label>
                  <input class="form-control" id="apn" v-model="record.apn" required>
                </div>
                <div class="form-group">
                  <label for="acreage">Acreage</label>
                  <input class="form-control" type="number" step=".01" id="acreage" v-model="record.acreage" required>
                </div>
                <div class="form-group">
                  <label for="name">Name</label>
                  <input class="form-control" id="name" v-model="record.name" required>
                </div>
                <div class="form-group">
                  <label for="re_recorded_deferral">Re-Recorded Deferral</label>
                  <input class="form-control" type="number" id="re_recorded_deferral" v-model="record.re_recorded_deferral" required>
                </div>
              </form>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-success" @click="save(record)">
                Save
              </button>
              <button class="btn btn-default" @click="$emit('close')">
                Close
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>


<script>
import router from "../router";
export default {
  name: "new-record-modal",
  components: {},
  data() {
    return {
      record: { apn: "", name: "", acreage: "", re_recorded_deferral: "" },
      searchText: ""
    };
  },
  methods: {
    reset() {
      this.item = {};
    },
    save(record) {
      this.$store.dispatch("createRecord", record).then(response => {
        this.$emit("close");
        router.push({
          name: "Detail",
          params: { id: response.data.id, showModal: true }
        });
      });
    }
  }
};
</script>


<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 80%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
